import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { useLocation } from "react-router-dom";
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../../routes/routes";
import Footer from "components/Footer/Footer";
import { Helmet } from "react-helmet-async";

var ps;

function InformacionHuerta(props) {
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
        document.body.classList.toggle("perfect-scrollbar-on");
      }
    };
  });

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Información de la Huerta</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="wrapper">
        <Sidebar {...props} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <div>
            <DemoNavbar {...props} />
            <div className="p-5">
              <div>
                <p className="p-0 m-0 text-center text-sm-left h4 font-weight-bold">
                  NOVEDADES Y AVISOS
                </p>
                <hr></hr>
                <div className="pl-5 pt-3 pr-5">
                  <a href="http://52.17.106.173/docs/INFORMACION583.zip">
                    <p className="p-0 m-0 font-weight-bold">
                      Información Nuevo Impuesto sobre el valor de producción de
                      energía eléctrica (25/09/2013)
                    </p>
                  </a>
                  <p className="p-0 m-0 mt-5 font-weight-bold mb-3">
                    Cambios legislación vigente. Documentos de Interés
                  </p>
                  <ul>
                    <li>
                      Publicación del BOE sobre el nuevo modelo 513 Este modelo
                      debe presentarse telemáticamente en la web de hacienda
                      anualmente,antes del 31 de Marzo.
                    </li>
                  </ul>
                  <p className="p-0 m-0 font-weight-bold mb-3">
                    Pago peajes a Distribuidora y envio información (29/12/2011){" "}
                  </p>
                  <ul>
                    <li>
                      <a href="">Descarga nota informativa</a> ,{" "}
                      <a href="">Excel a cumplimentar</a> y
                      <a href=""> extracto RD 1244/2011</a>
                    </li>
                  </ul>
                  <hr></hr>
                  <p className="p-0 m-0 font-weight-bold mt-5 mb-3">
                    Recordamos:
                  </p>
                  <ul>
                    <li className="mb-3">
                      Como cada año, y antes del 30 de Marzo, los titulares de
                      las instalaciones fotovoltaicas están obligados a
                      presentar ante la Junta la memoria resumen anual de su
                      instalación según indica el real decreto 661/2007 en su
                      artículo 17.
                    </li>
                    <li>
                      Consultas a Endesa referente a vencimientos y fechas de
                      pago en el teléfono de CENIT: 91 213 48 48
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default InformacionHuerta;
